import React, { useState } from "react";
import { post } from "aws-amplify/api";

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    feedback: "",
  });
  const [status, setStatus] = useState("");
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(current => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSending) return;
    setIsSending(true);
    setStatus("Sending...");
    try {
      const request = post({
        apiName: "feedbackAPI",
        path: "/sendfeedback",
        options: { body: formData },
      });
      await request.response;
      setStatus("Feedback sent successfully!");
      setFormData({ name: "", email: "", feedback: "" }); // Reset form
    } catch (error) {
      console.error("Error:", error);
      setStatus("Error sending feedback. Please try again.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="feedback-container wrap">
      <p className="eyebrow">We’re here to help</p>
      <h1>Contact Focus Cards</h1>
      <p>Have a question, an idea, or a privacy request? Send us a message.</p>
      <p className="small-note">Please use a parent or caregiver’s details and avoid including sensitive child information. See our <a href="/privacy-policy">Privacy Policy</a> for how support information is used.</p>
      <form className="feedback-form" onSubmit={handleSubmit}>
        <label htmlFor="support-name">Your name</label>
        <input
          id="support-name"
          autoComplete="name"
          className="feedback-input"
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <label htmlFor="support-email">Email address</label>
        <input
          id="support-email"
          autoComplete="email"
          className="feedback-input"
          type="email"
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <label htmlFor="support-message">How can we help?</label>
        <textarea
          id="support-message"
          className="feedback-textarea"
          name="feedback"
          placeholder="Your Feedback"
          value={formData.feedback}
          onChange={handleChange}
          required
        />
        <button className="button" type="submit" disabled={isSending}>
          {isSending ? "Sending…" : "Send message"}
        </button>
      </form>
      <p className="feedback-status" role="status" aria-live="polite">{status}</p>
    </section>
  );
};

export default FeedbackForm;
